import Http from "@/lib/Http"

// Records the artwork a guest tapped so Rails adds it to the guest_favourites
// cookie, to be favourited on sign-in/up via User::AddGuestFavourites.
export default (listingId) => Http({ method: "POST", url: "/api/guest_favourites", params: { id: listingId } })
